import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faLink,
} from "@fortawesome/free-solid-svg-icons";

const LinkAnalysisSection = ({ urlAnalyses }) => {
  if (!urlAnalyses || urlAnalyses.length === 0) return null;

  return (
    <div
      className="link-analysis-section"
      style={{ marginTop: "var(--spacing-md, 12px)" }}
    >
      <h4 className="subsection-title">
        <FontAwesomeIcon icon={faLink} /> Link Analysis
      </h4>
      <div className="link-list">
        {urlAnalyses.map((entry, index) => {
          const analysis = entry.analysis || {};
          return (
            <div
              key={index}
              className="link-item"
              style={{ marginTop: "0.75rem" }}
            >
              <div
                className="link-item-header"
                style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
              >
                <a
                  href={entry.url}
                  target="_blank"
                  rel="noreferrer"
                  className="link-url"
                >
                  {entry.url}
                </a>
                {analysis.wasRedirect && analysis.url && (
                  <span
                    className="redirect-resolved"
                    style={{
                      marginLeft: "0.5rem",
                      color: "var(--text-secondary)",
                    }}
                  >
                    → {analysis.url}
                  </span>
                )}
                <div style={{ marginLeft: "auto" }}>
                  {analysis.isScam === false && (
                    <span className="status-badge safe">Appears Safe</span>
                  )}
                  {analysis.isScam === true && (
                    <span className="status-badge dangerous">
                      Potentially Dangerous
                    </span>
                  )}
                  {analysis.isScam == null && (
                    <span className="status-badge unknown">Unknown</span>
                  )}
                </div>
              </div>

              {entry.error && (
                <div className="error-message" style={{ marginTop: "0.5rem" }}>
                  <FontAwesomeIcon icon={faExclamationTriangle} /> {entry.error}
                </div>
              )}

              {analysis.explanation && (
                <div
                  className="link-explanation"
                  style={{ marginTop: "0.5rem" }}
                  dangerouslySetInnerHTML={{ __html: analysis.explanation }}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LinkAnalysisSection;
